import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { rentalAPI, errText } from '../../lib/rentalRegisterAPI';

// Upload + list for property documents. scope: 'permanent' (categorised) | 'annual' (property_fy_id required)
export const PropertyDocs = ({ pid, docs, scope, fyId, categories, canUpload, canApprove, reload, checklistKey, requestId }) => {
  const [cat, setCat] = useState(categories?.[0] || '');
  const up = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file); fd.append('doc_scope', scope);
    if (scope === 'permanent') fd.append('permanent_category', cat);
    if (fyId) fd.append('property_fy_id', fyId);
    if (checklistKey) fd.append('checklist_key', checklistKey);
    if (requestId) fd.append('request_id', requestId);
    try { await rentalAPI.upload(pid, fd); toast.success('Uploaded'); reload(); } catch (err) { toast.error(errText(err)); }
    e.target.value = '';
  };
  const groups = scope === 'permanent' ? categories.map((c) => [c, docs.filter((d) => d.permanent_category === c)]) : [['', docs]];
  return (
    <div className="space-y-2 text-sm" data-testid={`docs-${scope}`}>
      {canUpload && <div className="flex items-center gap-2">
        {scope === 'permanent' && <select className="border rounded h-8 px-1" value={cat} onChange={(e) => setCat(e.target.value)} data-testid="docs-category">{categories.map((c) => <option key={c}>{c}</option>)}</select>}
        <Input type="file" className="h-8 w-64" onChange={up} accept=".pdf,.jpg,.jpeg,.png,.heic,.doc,.docx,.xls,.xlsx,.csv" data-testid={`docs-upload-${scope}`} /></div>}
      {groups.map(([c, list]) => (list.length > 0 || scope !== 'permanent') && (
        <div key={c || 'all'}>{c && <p className="text-[11px] uppercase text-muted-foreground">{c}</p>}
          {list.length === 0 && <p className="text-xs text-muted-foreground">No documents.</p>}
          {list.map((d) => <div key={d.id} className="flex items-center gap-2 text-xs py-0.5" data-testid={`doc-${d.id}`}>
            <span className="flex-1 truncate">{d.filename}</span><span className="text-muted-foreground">{d.source === 'client_portal' ? 'client' : 'staff'} · {new Date(d.uploaded_at).toLocaleDateString('en-AU')}</span>
            <span className={d.status === 'accepted' ? 'text-emerald-700' : 'text-muted-foreground'}>{d.status === 'accepted' ? 'Approved' : 'Pending review'}</span>
            {canApprove && d.status !== 'accepted' && <Button size="sm" variant="ghost" className="h-6" onClick={() => rentalAPI.approveDoc(d.id).then(reload)} data-testid={`doc-approve-${d.id}`}>Approve</Button>}
          </div>)}</div>))}
    </div>
  );
};
